export default __webpack_public_path__ + "static/media/ico_user_guide3.623cd56b.png";